import { createContext, useEffect, useMemo, useRef, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  matchPath,
  useLocation,
  useParams,
} from 'react-router-dom';
import {
  submitDemurrageExtension,
  fetchCFSNameByCountry,
  fetchEmptyYardNameByCountry,
  getApprovalLevels,
  getAttachmentsOnlyDOExtension,
  getDefoultPickuLocation,
  getDeliveryOrderDataForExtensionNew,
  getDemurrage,
  getDoExtenstionDetails,
  getInstructionDocTemplates,
  getInstructionList,
  getLastestExtensionRequest,
  getOBLDetails,
  getReleasePOPDetails,
  getReleaseTypeList,
  getRequestInstructionConfigByType,
  getTrukerNameList,
  getUnstuffingTypeList,
  updateIsProcessingFlag,
  getApprovalConfigByInstructionName,
} from '../../../dashboard/actions/instruction';
import { AppDispatch, RootState } from '../../../template/store';

import moment from 'moment';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { AESDecrypt } from '../../../../../encrypt-util';
import {
  clearFields,
  clearPickupLocation,
  updateAdttamentData,
  updateDemurrageList,
  updateSelectedAttachmentFilePath,
  updateSelectedAttachmentName,
  updateSelectedCfsName,
  updateSelectedDateDV,
  updateSelectedPickupLocation,
  updateSelectedTruckerName,
  updateSelectedemptyYardName,
  updateSelectedtruckerCode,
  updateSelectedtruckerId,
  resetDemurrageViewSlice,
  updateAttachmentDataForExtension
} from '../instructionSlice/DOExtensionSlice';

import UnsavedChangesModal from '../../../../../components/common/UnsavedChangesModal';
import { getUnprefixedPathname } from '../../../../../helpers/utils';
import { useBackNavigation } from '../../../../../hooks/BackNavigation';
import useBlCountry from '../../../../../hooks/useBlCountry';
import useDataCountry from '../../../../../hooks/useDataCountry';
import { useFormNavigationWarning } from '../../../../../hooks/useFormNavigationWarning';
import { getAppConfig } from '../../../../common/actions/userDetails';
import { updateDashbaordRefresh } from '../../../../common/components/DataTable/slices/DataTable';
import { clearPOPLInerData } from '../../../crrpop/InvoiceUnpaidSlice';
import { getReleaseAttConfForExtension } from '../actions/Instruction';

import { extensionTypeList } from '../../../dashboard/actions/instruction';

import useConsole from '../../../../../hooks/useConsole';
import { useLinerConfig } from '../../../../../hooks/useLinerConfig';
import { updateNavigateFlag } from '../instructionSlice/OverstayExtensionSlice';
import DoGeneratedDialogModal from './components/Modals/DoGeneratedDialogModal';
import InvoiceModal from './components/Modals/InvoiceModal';
import { getReleaseInstructionCountryConfig } from './config';
import DOExtensionForm from './components/DOExtensionForm';
import DOExtensionHeader from './components/DOExtensionHeader';
import { DoExtensionFormValues, doExtensionResolver } from './validation/doExtensionValidation';
import { useLoading } from '../../../../../middleware/loadingMiddleware';

type ApprovalLevelOption = { label: string; value: number };

export type ReleaseInstructionState = {
  submitFlag: boolean;
  submitOn: boolean;
  currStatus: any;
  isEdit: boolean;
  isDraft: boolean;
  blNumDisplay: string;
  releaseType: string;
  senderEmail: any;
  requestedPartnerName: string;
  dndInstructionId: string;
  remarks: string;
  userRemarks: string;
  doUploadStatus: string;
  doIntegrationRemarks: string;
  attachedFileSize: number;
  loadingFileState: Record<string, number>;
  doExtensionSoftStopConfig: string;
  DoExtensonCheckBoxShow: string;
  doGeneratedAmsConfig: string;
  extensionInvoiceCheck: string;
  showUnstuffingTypeConfig: string;
  cfsOrEmptyYardByLocationConfig: string;
  showPickupLocationFields: boolean;
  showDoUploadStatus: boolean;
  isSavedDoNumber: boolean;
  isProcessing: string;
  isDemurrageRequestAbsent: boolean;
  templateList: any[];
  showDoGeneratedDialog: boolean;
  doGeneratedAMS: 'Y' | 'N';
  truckerCodearray: any;
  disableFields: any;
  selectedContainerInput: string;
  extensionTypeOption: any[];
  unstuffingTypeOptions: any[];
  selectedNeedExtensionFor: any;
  approvalLevelsOptions: ApprovalLevelOption[];
  existingDoRequest: any;
};

const initialState: ReleaseInstructionState = {
  submitFlag: false,
  submitOn: false,
  currStatus: '',
  isEdit: false,
  isDraft: false,
  blNumDisplay: '',
  releaseType: '',
  senderEmail: '',
  requestedPartnerName: '',
  dndInstructionId: '',
  remarks: '',
  userRemarks: '',
  doUploadStatus: '',
  doIntegrationRemarks: '',
  attachedFileSize: 0,
  loadingFileState: {},
  doExtensionSoftStopConfig: 'No',
  DoExtensonCheckBoxShow: 'No',
  doGeneratedAmsConfig: 'N',
  extensionInvoiceCheck: 'N',
  showUnstuffingTypeConfig: 'No',
  cfsOrEmptyYardByLocationConfig: 'No',
  showPickupLocationFields: true,
  showDoUploadStatus: false,
  isSavedDoNumber: false,
  isProcessing: '',
  isDemurrageRequestAbsent: false,
  templateList: [],
  showDoGeneratedDialog: false,
  doGeneratedAMS: 'N',
  truckerCodearray: [],
  disableFields: false,
  selectedContainerInput: '',
  extensionTypeOption: [],
  unstuffingTypeOptions: [],
  selectedNeedExtensionFor: {},
  approvalLevelsOptions: [],
  existingDoRequest: {}
};

export const ReleaseInstructionConfigContext = createContext<any>(null);

const DOExtenstion = () => {
  const [state, setState] = useState<ReleaseInstructionState>(initialState);
  const {
    submitOn,
    currStatus,
    isDraft,
    blNumDisplay,
    releaseType,
    senderEmail,
    requestedPartnerName,
    dndInstructionId,
    remarks,
    userRemarks,
    doUploadStatus,
    doIntegrationRemarks,
    loadingFileState,
    doExtensionSoftStopConfig,
    extensionInvoiceCheck,
    showUnstuffingTypeConfig,
    cfsOrEmptyYardByLocationConfig,
    showPickupLocationFields,
    isProcessing,
    isDemurrageRequestAbsent,
    templateList,
    showDoGeneratedDialog,
    doGeneratedAMS,
    truckerCodearray,
    disableFields,
    selectedNeedExtensionFor,
    existingDoRequest
  } = state;

  const instructionLoading = useLoading(['instruction/getDoExtenstionDetails'])


  const setSubmitOn = (value: boolean) =>
    setState(prev => ({ ...prev, submitOn: value }));

  const setShowDemurrgaeOrDeliveryModal = (value: boolean) =>
    setState(prev => ({ ...prev, isDemurrageRequestAbsent: value }));
  const setShowDoGeneratedDialog = (value: boolean) =>
    setState(prev => ({ ...prev, showDoGeneratedDialog: value }));
  const setDoGeneratedAMS = (
    updater: 'Y' | 'N' | ((prev: 'Y' | 'N') => 'Y' | 'N')
  ) => {
    const nextValue =
      typeof updater === 'function'
        ? (updater as (prev: 'Y' | 'N') => 'Y' | 'N')(doGeneratedAMS)
        : updater;
    setState(prev => ({ ...prev, doGeneratedAMS: nextValue }));
  };

  const oblNumber = useSelector((x: RootState) => x.oblDetails.oblForm.number)
  const blidDocHistory: any = useSelector((state: RootState) => state.documentHistory.data?.[0]?.blId);
  const dataObl = useSelector((state: RootState) => state.instructionSlice.dataObl)
  const oblForm = useSelector((state: RootState) => state.oblDetails.oblForm);
  const instructionList = useSelector((state: RootState) => state.documentHistory.data);
  const data = useSelector((state: RootState) => state.doExtension.data);
  const profileDetails = useSelector((state: RootState) => state.userProfile.profile);
  const docAttachment = useSelector((state: RootState) => state.doExtension.attData);
  const extensionAttData = useSelector((state: RootState) => state.doExtension.extensionAttData);
  const serverFilePath = useSelector((state: RootState) => state.doExtension.selectedFileServerPath);
  const isDirty = useSelector((state: RootState) => state.formDirty.isDirty);
  const docList = useSelector((state: RootState) => state.doExtension.docList);
  const extensionDocList = useSelector((state: RootState) => state.doExtension.extensionDocList);
  const csfList = useSelector((state: RootState) => state.doExtension.cfsList);
  const emptyYardList = useSelector((state: RootState) => state.doExtension.emptyYardList);
  const dataList = useSelector((state: RootState) => state.doExtension.data);
  const userEmail = useSelector((state: RootState) => state.userProfile.profile.email);
  const selectedLinerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const selectedDate = useSelector((state: RootState) => state.doExtension.selectedDate);
  const selectedinternalCode = useSelector((state: RootState) => state.doExtension.selectedinternalCode);
  const selectedAttachmentName = useSelector((state: RootState) => state.doExtension.selectedAttachmentName);
  const selectedDefaultPickupLocation = useSelector((state: RootState) => state.doExtension.selectedDefaultPickupLocation);
  const selectedAttachmentFilePath = useSelector((state: RootState) => state.doExtension.selectedAttachmentFilePath);
  const checkListData = useSelector((state: RootState) => state.doExtension.checkList);
  const selectedPickupLocation = useSelector((state: RootState) => state.doExtension.selectedPickupLocation);
  const selectedCfsName = useSelector((state: RootState) => state.doExtension.selectedCfsName)
  const selectedEmptyYardName = useSelector((state: RootState) => state.doExtension.selectedemptyYardName)
  const selectedTruckerName = useSelector((state: RootState) => state.doExtension.selectedTruckerName);
  const selectedTruckerCode = useSelector((state: RootState) => state.doExtension.selectedTruckerCode);
  const selectedtruckerId = useSelector((state: RootState) => state.doExtension.selectedtruckerId);
  const releaseTypeList = useSelector((state: RootState) => state.invoiceChange.releaseTypeList, shallowEqual);
  const demurrageForm = useSelector((state: RootState) => state.doExtension.demurrageForm);
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const demurrageViewForm = useSelector((state: RootState) => state.doExtension.demurrageFormView);
  console.log(currStatus, "currStatus")
  const recentId = useSelector((state: RootState) => {
    const arr = state?.documentHistory?.data?.filter(
      (inst) =>
        inst.instructionId == 820 &&
        (inst.event == 'Submitted' || inst.event == 'Draft' || inst.event == 'Not Submitted')
    );
    const recentInst = arr.length <= 0 ? null :
      arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b))

    return ['Y', '1', '2', '3', '4', '5', '6'].includes(recentInst?.docStatus ?? '')
      ? null
      : recentInst;
  });
  const recentCompletedId = useSelector((state: RootState) => {
    const arr = state?.documentHistory?.data?.filter(
      (inst) =>
        inst.instructionId == 804 &&
        (inst.event == 'Completed')
    );
    return arr.length <= 0 ? null :
      arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b))
  });
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const configs = useSelector((state: RootState) => state.instructionSlice.linerConfig);

  const onBack = useBackNavigation();
  const formRef = useRef<HTMLFormElement>(null);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { blNum, encrypt, encryptdoc, blId } = useParams();
  console.log(useParams(), "useparams1")
  const decrptdoc = AESDecrypt(encryptdoc);
  const decrptins = AESDecrypt(encrypt);
  const docId = decrptins;
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const methods = useForm<DoExtensionFormValues>({
    resolver: doExtensionResolver,
    mode: 'onChange',
  });

  const {
    handleSubmit,
    setValue,
    setError,
    watch,
  } = methods;
  const ShowInvoiceModal = isDemurrageRequestAbsent && (extensionInvoiceCheck ?? "") == 'Y'

  const doExtension = watch('doExtension');
  const displayNumber = blNumDisplay ? blNumDisplay : oblNumber ? oblNumber : '';
  const matchPth = [
    {
      path: `${APP_PATH_PREFIX}/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[3] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/payment/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    { path: `${APP_PATH_PREFIX}/instruction/:blNum/:encrypt/:encryptdoc` },
  ].some(({ path, condition }: { path: string; condition?: boolean }) => {
    return (
      (condition ?? true) &&
      matchPath({ path, caseSensitive: true, end: true }, location.pathname)
    );
  });

  const closeDoGeneratedDialog = () =>
    setState(prev => ({ ...prev, showDoGeneratedDialog: false }));

  const updateIsProcessing = (async (payload: any) => {
    dispatch(updateIsProcessingFlag(payload))
      .unwrap()
      .then((response) => {
        console.log('Processing flag updated successfully', response);
        // toast.success('Marked as Processing successfully!');
      })
      .catch((error) => {
        console.error('Failed to update processing flag', error);
        // toast.error('Failed to mark as Processing');
      });
  });


  //Non released Bl container Data
  const dataCountry = useDataCountry();
  useConsole("ATTACHMENTS ", extensionAttData, docAttachment)
  const handleCopyBL = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling up
    try {

      if (dataObl) {
        await navigator.clipboard.writeText(displayNumber || '');;
        //  toast.success(t('resource_2:copiedToClipboard') as string);
      } else {
        toast.error(t('resource_2:copyFailed') as string);
      }
    } catch (error) {
      console.error('Copy failed:', error);
      toast.error(t('resource_2:copyFailed') as string);
    }
  };

  const [blCountry, setBlCountry] = useBlCountry(
    matchPth ? "view" : "new",
    "import",
    820
  );

  const releaseInstructionConfig = getReleaseInstructionCountryConfig(blCountry, linerId);
  
  const linerConfig = useLinerConfig(blCountry, linerId, 820);
  const formDataInvoiceModal = useMemo(() => {
    return {
      senderEmail,
      requestedPartnerName,
      releaseType,
      userRemarks,
      doUploadStatus,
      doIntegrationRemarks,
      remarks,
      selectedDate,
      selectedPickupLocation,
      selectedTruckerName,
      selectedTruckerCode,
      selectedtruckerId,
      selectedinternalCode,
      selectedAttachmentName,
      selectedAttachmentFilePath,
      selectedNeedExtensionFor
    }
  }, [senderEmail,
    requestedPartnerName,
    releaseType,
    userRemarks,
    doUploadStatus,
    doIntegrationRemarks,
    remarks,
    selectedDate,
    selectedPickupLocation,
    selectedTruckerName,
    selectedTruckerCode,
    selectedtruckerId,
    selectedinternalCode,
    selectedAttachmentName,
    selectedAttachmentFilePath,
    selectedNeedExtensionFor]);

  const version = useMemo(() => {
    const dndInstructionID = demurrageViewForm?.dndInstructionId || null;
    return ((!dndInstructionID && !demurrageViewForm?.version) ? 0 : demurrageViewForm?.version) ?? null
  }, [
    demurrageViewForm?.status,
    demurrageViewForm?.dndInstructionId,
    demurrageViewForm?.version
  ]);

  const onSubmit = handleSubmit(async (payload) => {
    //api 1 response empty means
    dispatch(updateNavigateFlag(false))
    if ((showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes') {
      if (!watch('unstuffingType') || watch('unstuffingType') === '0') {
        setError('unstuffingType', {
          type: 'manual',
          message: 'Please select a valid Unstuffing Type',
        });
        return;
      }
    }
    setState(prev => ({ ...prev, submitFlag: true }));
    const idValueMap: { [id: string]: string } = {};
    truckerCodearray.forEach((item: { id: string | number; value: string }) => {
      idValueMap[item.id] = item.value;
    });

    const docAttachmentKey =  extensionAttData;
    const viewFormAttKey = demurrageViewForm.extensionAttList;

    const isShowUnstuffingType = ((showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes')
    const unstuffingTypeValue = watch('unstuffingType')
    const dndInstructionID = demurrageViewForm?.status != 'Submitted' && !demurrageViewForm?.status?.includes('Rejected')
      ? null
      : demurrageViewForm?.dndInstructionId || null
    try {
      await dispatch(
        submitDemurrageExtension({
          ...payload,
          unstuffing: (isShowUnstuffingType && unstuffingTypeValue) ? unstuffingTypeValue : '',
          requestedPartnerId: profileDetails?.partnerId,
          blId: AESDecrypt(blNum),
          country: blCountry,
          dndInstructionId: dndInstructionID,
          senderEmail: senderEmail,
          remarks: (linerId != '24118' && instructionList
            .filter(
              (v: any) => v?.docId === demurrageViewForm?.dndInstructionId
            )
            .map((u: any) => u?.event?.includes('Rejected'))
            .includes(true))
            ? ''
            : demurrageViewForm?.remarks || '',
          userRemarks: userRemarks,
          status: isDraft ? "Draft" :
            demurrageViewForm.groupLevel ? `Approved by L${demurrageViewForm.groupLevel}` :
              "Submitted",
          list: data?.list
            ?.filter((v: any) =>
              releaseInstructionConfig?.fields?.filterCompletedContainers
                ? !(v.cntStatus === 'Completed') &&
                selectedTruckerCode?.[v.containerNo]
                : true
            )
            .map?.((d: any) => ({
              ...d,
              containerPickupId:
                demurrageViewForm?.list?.find(
                  (x: any) => d?.containerNo === x?.containerNo
                )?.containerPickupId || null,
              //  truckerCode: inputRef.current?.value,
              /*  truckerCode: updatedArray.find(
              (code) => code.id == d.blContainerId.toString()
            )?.value, */
              truckerCode: d?.containerNo
                ? selectedTruckerCode?.[d.containerNo]
                  ? selectedTruckerCode?.[d.containerNo]
                  : null
                : null,
              truckerId: d?.containerNo
                ? selectedtruckerId?.[d.containerNo]
                  ? selectedtruckerId?.[d.containerNo]
                  : null
                : null,

              internalCode: d?.containerNo
                ? selectedinternalCode?.[d.containerNo]
                  ? selectedinternalCode?.[d.containerNo]
                  : null
                : null,
              pickupLocation: d?.containerNo
                ? selectedPickupLocation?.[d.containerNo]
                  ? selectedPickupLocation?.[d.containerNo]
                  : null
                : null,

              extensionFor: d?.containerNo
                ? selectedNeedExtensionFor?.[d.containerNo]
                  ? selectedNeedExtensionFor[d.containerNo]
                  : null
                : null,
              truckerName: d?.containerNo
                ? selectedTruckerName?.[d.containerNo]
                  ? selectedTruckerName?.[d.containerNo]
                  : null
                : null,
              pickupDate: d?.containerNo
                ? selectedDate?.[d.containerNo]
                  ? moment(selectedDate?.[d.containerNo] + ' UTC')?.format(
                    'YYYY-MM-DD'
                  )
                  : null
                : null,
            })),
          extensionDoNo: payload.doNumber,
          docList: docAttachmentKey?.list?.filter((d: { docId: string }) => loadingFileState[d.docId] != -1).map?.((d: any) => {
            const key = d?.dndInstructionAttId ?? d?.rowNumber ?? null;
            return {
              ...d,
              dndInstructionAttId: (demurrageViewForm.status == 'Submitted') ||
                (demurrageViewForm.status == 'Not Submitted') ||
                (demurrageViewForm.status == 'Draft') ?
                viewFormAttKey?.find(
                  (x: any) => d?.docId === x?.docId
                )?.dndInstructionAttId ?? null : null,
              docId: d?.docId,
              filePath: d?.docId ? selectedAttachmentFilePath?.[key] : null,
              fileName: d?.docId ? selectedAttachmentName?.[key]?.name : null,
              serverPath: d?.docId ? serverFilePath?.[key]?.[0] : null,
              tempFileName: d?.docId ? serverFilePath?.[key]?.[1] : null,
            }
          }),
          docId,
          checkList: checkListData,
          groupLevel: demurrageViewForm?.groupLevel ?? 0,
          linerId: +selectedLinerId,
          version: version,
        })
      );

    } catch (err: any) {
      console.error(err.message);
      console.error(err.message);
    }

    //dispatch(getInstructionList(AESDecrypt(blNum)));
    setTimeout(() => {
      dispatch(
        getInstructionList({
          blNum: AESDecrypt(blNum),
          country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
        })
      );
      dispatch(updateDashbaordRefresh(true))
    }, 3500);

    onBack()

    setState(prev => ({ ...prev, submitFlag: false, isEdit: false }));
  }, (e) => { console.log("VALIDATION", e) });

  const setInitialValue = () => {
    if (blNum) {
      const selectedDataDemurrage = dataList?.list?.find?.(
        (i: any) => i?.blId == AESDecrypt(blNum)
      );
      if (demurrageViewForm?.extensionAttList?.length > 0) {
        dispatch(updateAttachmentDataForExtension(demurrageViewForm.extensionAttList));
      }
      if (selectedDataDemurrage) {
        setState(prev => ({
          ...prev,
          senderEmail: selectedDataDemurrage?.senderEmail,
          remarks: selectedDataDemurrage?.remarks,
          requestedPartnerName: selectedDataDemurrage?.requestedPartnerName,
          releaseType: selectedDataDemurrage?.releaseType,
        }));
      }
    }
  };



  const { showModal, handleCancel, handleBack } = useFormNavigationWarning({
    isChanged: isDirty,
    isEditable: true,
    onConfirm: onBack // or onBack, or your navigation function
  });

  const handleStayOnPage = () => {
    handleCancel();
  };

  const handleLeavePage = () => {
    onBack()
  };





  const configKey = `${dataCountry}_${linerId}_${dndInstructionId}_${location}`;
  const fetchedRef = useRef<Record<string, boolean>>({});
  const config = configs?.[configKey];

  //const docList = { 101: 'Bill of entry' };




  const loadApprovalLevels = () => {
    const partnerId =
      profileDetails.partnerType === 'liner'
        ? profileDetails.partnerId
        : selectedLinerId;
    if (!partnerId || !blCountry) return;

    const payload = {
      partnerId,
      countryCode: blCountry,
      actionType: 'REJECT',
      groupLevel: demurrageViewForm.groupLevel,
      name: "EXTENSION INSTRUCTION"
    };

    dispatch(getApprovalConfigByInstructionName(payload))
      .then((res: any) => {
        if (res.payload.defaultValue >= 0 && res.payload.approvalList.length > 0) {
          setState(prev => ({ ...prev, approvalLevelsOptions: res.payload.approvalList }));
          setValue('selectedApprovalLevel', res.payload.defaultValue);
        }
      })
      .catch(() => {
        setState(prev => ({ ...prev, approvalLevelsOptions: [] }));
      });
  };

  useEffect(() => {
    loadApprovalLevels();
  }, [profileDetails.partnerId, blCountry, demurrageViewForm.groupLevel]);

  useEffect(() => {
    if (profileDetails?.partnerType) {
      setState(prev => ({
        ...prev,
        disableFields:
          profileDetails?.partnerType === 'liner' ||
          (!!matchPth && profileDetails?.partnerType !== 'liner'),
      }))
    }
  }, [profileDetails?.partnerType, matchPth])


  useEffect(() => {
    if (releaseTypeList?.length > 0) {
      setState(prev => ({ ...prev, releaseType: releaseTypeList[0]?.value }));
    }
  }, [releaseTypeList]);

  useEffect(() => {
    if (userEmail) {
      setState(prev => ({ ...prev, senderEmail: userEmail }));
    }
  }, [userEmail])

  const loadLatestExtensionRequest = () => {
    // if (!disableFields || !blNum || !linerId || !data.list) {
    //   setState(prev => ({ ...prev, isDemurrageRequestAbsent: false }));
    //   return;
    // }

    if (!disableFields && blNum && linerId && data.list) {


    dispatch(getLastestExtensionRequest({ blId: AESDecrypt(blNum), linerId }))
      .then((response: any) => {
        if (response?.payload?.data?.statusCode !== 400) {
          setState(prev => ({ ...prev, isDemurrageRequestAbsent: false }));
        } else {
          setState(prev => ({ ...prev, isDemurrageRequestAbsent: true }));
        }

        const containerList =
          response?.payload?.data?.containerDetails?.map((e: any) => ({
            containerNo: e?.cntNo,
            needExtensionFor: e?.pickupLocation,
            pickupDate: e?.pickupDate,
          })) || [];

        if (containerList.length > 0) {
          const needExtensionForMap: { [key: string]: string } = {};

          if (!recentId && !demurrageViewForm?.dndInstructionId) {
            const body = containerList
              .filter((container: any) => container.pickupDate.trim() != '')
              .reduce(
                (b: any, a: any) => ({ ...b, [a.containerNo]: new Date(a.pickupDate) }),
                selectedDate
              );
            dispatch(updateSelectedDateDV(body));

            setState(prev => ({
              ...prev,
              selectedNeedExtensionFor: needExtensionForMap,
            }));
          }
        }
      });
      } else {
        setState(prev => ({ ...prev, isDemurrageRequestAbsent: false }));
    }
  };

  useEffect(() => {
    loadLatestExtensionRequest();
  }, [linerId, dataCountry, blNum, dispatch, disableFields, data.list.length]);

  const fetchRequestInstructionConfig = () => {
    if (!linerId || !dataCountry) return;

    dispatch(
      getRequestInstructionConfigByType({
        linerId,
        country: dataCountry,
        // location: '',
        // currency: '',
        requestType: 'instruction',
        requestIdentifier: '820',
      })
    ).then((response: any) => {
      const configJsonString = response.payload.data[0]?.configJson;

      if (configJsonString) {
        try {
          const config = JSON.parse(configJsonString);
          setState(prev => ({
            ...prev,
            doExtensionSoftStopConfig: config.doExtensionRequestAllowed,
            DoExtensonCheckBoxShow: config.doExtensionRequestCheckBoxShow,
            doGeneratedAmsConfig: config.doGeneratedAms,
            extensionInvoiceCheck: config.extensionInvoiceCheck,
            showUnstuffingTypeConfig: config.showUnstuffingType,
            cfsOrEmptyYardByLocationConfig: config.cfsOrEmptyYardByLocation,
          }));
          if (config.showPickupLocationFields) {
            const showFields = config.showPickupLocationFields === 'Yes';
            dispatch(clearPickupLocation());
            setState(prev => ({ ...prev, showPickupLocationFields: showFields }));
          }
        } catch (e) {
          setState(prev => ({
            ...prev,
            doExtensionSoftStopConfig: 'No',
            DoExtensonCheckBoxShow: 'No',
            doGeneratedAmsConfig: 'N',
            extensionInvoiceCheck: 'N',
            showUnstuffingTypeConfig: 'No',
            cfsOrEmptyYardByLocationConfig: 'No',
          }));
        }
      }
    });
  };

  useEffect(() => {
    fetchRequestInstructionConfig();
  }, [linerId, dataCountry]); // Only depend on linerId and dataCountry

  const fetchAttachmentMaxSize = () => {
    dispatch(getAppConfig('attachment.maxsize'))
      .unwrap()
      .then((response: any) => {
        if (response !== '') {
          setState(prev => ({ ...prev, attachedFileSize: +response.response.data }));
        }
      });
  };

  useEffect(() => {
    fetchAttachmentMaxSize();
  }, []);

  const syncDoUploadStatusVisibility = () => {
    if (selectedCfsName?.label === 'TEAGTL' && profileDetails.partnerType === 'liner') {
      setState(prev => ({ ...prev, showDoUploadStatus: true }));
    } else {
      setState(prev => ({ ...prev, showDoUploadStatus: false }));
    }
  };

  useEffect(() => {
    syncDoUploadStatusVisibility();
  }, [selectedCfsName]);


  const syncCurrStatusFromForm = () => {
    setState(prev => ({ ...prev, currStatus: demurrageViewForm?.status }));
  };

  useEffect(() => {
    syncCurrStatusFromForm();
  }, [demurrageViewForm]);

  const loadDefaultPickupLocationAndDemurrage = () => {
    if (
      getUnprefixedPathname().split('/')[3] === 'instruction' ||
      getUnprefixedPathname().split('/')[4] === 'instruction'
    ) {
      dispatch(
        getDefoultPickuLocation({
          blId: AESDecrypt(blNum),
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails.partnerId
              : selectedLinerId,
        })
      );
    }

    dispatch(
      getDemurrage({
        docId: AESDecrypt(blNum),
        location: getUnprefixedPathname().split('/')[3],
        selectedLinerId:
          profileDetails.partnerType === 'liner'
            ? profileDetails.partnerId
            : selectedLinerId,
        showPickupLocationFields: showPickupLocationFields,
      })
    ).then();
  };

  useEffect(() => {
    loadDefaultPickupLocationAndDemurrage();
  }, [blNum, selectedLinerId]);

  const loadDemurrageViewData = () => {
    

    dispatch(resetDemurrageViewSlice(1));
    if (profileDetails.partnerType === 'liner') dispatch(clearPOPLInerData());
    if (!decrptdoc || !selectedLinerId) return;
    // if (!decrptdoc || !selectedLinerId) return;

    dispatch(
      getDoExtenstionDetails({
        docId: decrptdoc,
        // docList: docList,
        country: blCountry,
        liner: selectedLinerId,
        // dropdownDocList: dropdownDocList,
        docAttachment: docAttachment?.list,
        selectedLinerId:
          profileDetails.partnerType === 'liner'
            ? profileDetails.partnerId
            : selectedLinerId,
      })
    )
      .unwrap()
      .then((v: any) => {
        const containerList = v?.data?.list || v?.list || [];
        const selectedNeedExtensionForObj: { [containerNo: string]: string } = {};
        containerList.forEach((item: any) => {
          selectedNeedExtensionForObj[item.containerNo] = item.extensionFor || '';
        });

        setState(prev => ({
          ...prev,
          selectedNeedExtensionFor: selectedNeedExtensionForObj,
          isProcessing: v?.data?.isProcessing ?? '',
        }));
        setBlCountry(v?.data?.country);
        // setValue('doExtension', v?.data?.extFlag || 'N');
        setValue('doExtension', 'Y');
        setValue('doNumber', v?.data?.extensionDoNo);
        setState(prev => ({ ...prev, blNumDisplay: v?.data?.blNo }));
        if (!v?.data?.blId) {
          onBack();
          toast.error('Please Try Again');
          return;
        }
        if (v?.list?.length > 0) {
          dispatch(
            updateDemurrageList({
              list: data.list.filter((x: any) =>
                v?.list.map((y: any) => y?.containerNo).includes(x?.containerNo)
              ),
              next: null,
              previous: null,
            })
          );
        }

         setState(prev => ({
          ...prev,
          dndInstructionId: v?.data?.dndInstructionId,
        }));

        if (v?.data?.dndInstructionId) {

          setState(prev => ({
            ...prev,
            disableFields: true,
            isEdit: false,
          }));

        }

        setValue('unstuffingType', v?.data?.unstuffing || '');
        setState(prev => ({
          ...prev,
          remarks: v?.data?.remarks,
          userRemarks: v?.data?.userRemarks ?? '',
          doUploadStatus: v?.data?.doIntegrationStatus ?? '',
          doIntegrationRemarks: v?.data?.doIntegrationRemarks ?? '',
        }));
        if (v?.data?.extensionAttList.length > 0) {
          dispatch(updateAttachmentDataForExtension(v?.data?.extensionAttList));
        }
      });
  };

  useEffect(() => {
    loadDemurrageViewData();
  }, [decrptdoc, docId, location.pathname, !extensionDocList, selectedLinerId]);

  const initAttachmentsAndBlDisplay = () => {
    setState(prev => ({ ...prev, loadingFileState: {} }));
    dispatch(clearFields());

    if (blCountry && selectedLinerId && !decrptdoc && !recentId && blNum) {

      dispatch(getReleaseAttConfForExtension({ country: blCountry, liner: selectedLinerId, blId: AESDecrypt(blNum) }))
      .unwrap()
        .then((e: any) => {
          
          if (e?.existingDoRequest?.extensionDoNo) {
            setState(prev => ({ ...prev, isSavedDoNumber: true }));
            setValue('doNumber', e?.existingDoRequest?.extensionDoNo);
          }
            
          setState(prev => ({ ...prev, existingDoRequest: e?.existingDoRequest ?? {} }));

        
        })
        .catch((err) => {
          console.log("Thunk rejected:", err);
        });;
    }

    let payload: any = null;
    if ((!decrptdoc || decrptdoc?.length <= 0) && recentId?.docId && selectedLinerId) {
      payload = {
        id: recentId?.docId,
        selectedLinerId,
        country: blCountry,
        liner: selectedLinerId,
      };
    } else if (!disableFields) {
      payload = { id: null, country: blCountry, liner: selectedLinerId };
    }

    if (payload && blCountry && selectedLinerId) {
      dispatch(getAttachmentsOnlyDOExtension(payload))
        .unwrap()
        .then((data: any) => {
          setState(prev => ({ ...prev, blNumDisplay: data?.blNo }));
          // setValue('doExtension', data?.extFlag || 'Y');
          setValue('doExtension', 'Y');
          setValue('doNumber', data?.extensionDoNo);
          setValue('unstuffingType', data?.unstuffing || '');
        });
    }
  };

  useEffect(() => {
    initAttachmentsAndBlDisplay();
  }, [decrptdoc, recentId?.docId, selectedLinerId, blCountry, blNum, location.pathname, recentCompletedId?.docId, doExtension]);



  useEffect(() => {

    const deliveryOrder = (existingDoRequest?.dndInstructionAtt ?? []).find(
      (doc: any) => doc.docId == 206
    );
    if (!deliveryOrder) return;

    const docEntry = (extensionAttData?.list ?? []).find((doc: any) => doc?.docId == 309);
    if (!docEntry?.rowNumber) return;

    setState(prev => ({
      ...prev,
      loadingFileState: { ...(prev.loadingFileState ?? {}), [docEntry?.rowNumber]: 100 },
    }));
  }, [existingDoRequest, extensionAttData?.list, location.pathname]);


  // const loadDeliveryOrderDataForExtension = () => {

  //   if (!(blNum && selectedLinerId)) return;


  //   dispatch(
  //     getDeliveryOrderDataForExtensionNew({
  //       blId: AESDecrypt(blNum),
  //       selectedLinerId,
  //       country: blCountry,
  //       liner: selectedLinerId,
  //     })
  //   )
  //     .unwrap()
  //     .then((e: any) => {
  //       if (e?.extensionDoNo) {     
  //         setState(prev => ({ ...prev, isSavedDoNumber: true }));
  //         setValue('doNumber', e?.extensionDoNo);
  //       }

  //       const deliveryOrder = (e?.dndInstructionAtt ?? []).find(
  //         (doc: any) => doc.docId == 206
  //       );
  //       if (deliveryOrder) {
  //         console.log(deliveryOrder, "deliveryOrder")
  //         const docEntry = (extensionAttData?.list ?? [])?.find(
  //           (doc: any) => doc?.docId == 309
  //         );
  //         setState(prev => ({
  //           ...prev,
  //           loadingFileState: { ...loadingFileState, [docEntry.rowNumber]: 100 },
  //         }));
  //       }
  //     })
  //      .catch((err) => {
  //   console.log("Thunk rejected:", err);
  // });
  // };

  // useEffect(() => {
  //   loadDeliveryOrderDataForExtension();
  // }, [decrptdoc, docId, blNum, location.pathname, selectedLinerId, doExtension, recentCompletedId?.docId]);



  const resetPickupAndRemarksOnDocChange = () => {
    dispatch(updateSelectedPickupLocation({}));
    dispatch(updateSelectedTruckerName({}));
    dispatch(updateSelectedtruckerId({}));
    dispatch(updateSelectedAttachmentName({}));
    setState(prev => ({
      ...prev,
      userRemarks: '',
      doUploadStatus: '',
      doIntegrationRemarks: '',
    }));
    setInitialValue();
  };

  useEffect(() => {
    resetPickupAndRemarksOnDocChange();
  }, [docId]);

  const syncSelectedDataDemurrage = () => {
    if (!blNum) return;

    const selectedDataDemurrage = dataList?.list?.find?.(
      (i: any) => i?.blId == AESDecrypt(blNum)
    );
    if (!selectedDataDemurrage) return;

    setState(prev => ({
      ...prev,
      senderEmail: selectedDataDemurrage?.senderEmail
        ? selectedDataDemurrage?.senderEmail
        : senderEmail,
      remarks: selectedDataDemurrage?.remarks || '',
      requestedPartnerName: selectedDataDemurrage?.requestedPartnerName || '',
      releaseType: selectedDataDemurrage?.releaseType || '',
    }));
  };

  useEffect(() => {
    syncSelectedDataDemurrage();
  }, [dataList, blNum, location.pathname]);

  const loadOblDetailsIfRequired = () => {
    if (
      blNum &&
      selectedLinerId &&
      releaseInstructionConfig?.fields.getOblDetails &&
      (profileDetails.partnerType == 'liner' || !location.pathname.includes('/bl/'))
    ) {
      dispatch(
        getOBLDetails({
          blNumber: AESDecrypt(blNum) || null,
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails?.partnerId
              : selectedLinerId,
        })
      );
    }
  };

  useEffect(() => {
    loadOblDetailsIfRequired();
  }, [blNum, selectedLinerId, blCountry]);

  const maybeFetchReleasePOPDetails = () => {
    const blIdForPaymentGrid = AESDecrypt(blNum) ?? demurrageViewForm.blId ?? blidDocHistory;

    if (
      profileDetails?.partnerType === 'liner' &&
      blIdForPaymentGrid && (linerConfig.crrUnpaidHardStop === 'Y' || linerConfig.crrUnpaidSoftStop === 'Y')
    ) {
      dispatch(getReleasePOPDetails({ blid: blIdForPaymentGrid, country: blCountry }));
    }
  };

  useEffect(() => {
    maybeFetchReleasePOPDetails();
  }, [
    profileDetails?.partnerType,
    blId,
    blidDocHistory,
    demurrageViewForm.blId,
    blCountry
  ])

  const fetchCfsAndEmptyYardNames = () => {
    if (!currStatus) return;

    const byLocation =
      (cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes' &&
      profileDetails.partnerType == 'liner';
    const port =
      (cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes'
        ? oblForm.importLocation
        : null;

    dispatch(
      fetchCFSNameByCountry({
        country: dataCountry,
        port,
        byLocation,
      })
    );
    dispatch(
      fetchEmptyYardNameByCountry({
        country: dataCountry,
        port,
        byLocation,
      })
    );
  };

  useEffect(() => {
    fetchCfsAndEmptyYardNames();
  }, [dataCountry, oblForm.exportLocation, currStatus, oblForm.importLocation, cfsOrEmptyYardByLocationConfig])

  const hydrateSelectedCfsAndEmptyLabels = () => {
    if (selectedCfsName?.value && !selectedCfsName?.label) {
      const label = csfList.find((x: { value: string }) => x?.value == selectedCfsName?.value)?.text;
      if (label)
        dispatch(
          updateSelectedCfsName({
            value: selectedCfsName?.value,
            label: label ?? null,
          })
        );
    }
    if (selectedEmptyYardName?.value && !selectedEmptyYardName?.label) {
      const labelEmpty = emptyYardList.find((x: { value: string }) => x?.value == selectedEmptyYardName?.value)?.text;
      if (labelEmpty)
        dispatch(
          updateSelectedemptyYardName({
            value: selectedEmptyYardName?.value,
            label: labelEmpty ?? null,
          })
        );
    }
  };

  useEffect(() => {
    hydrateSelectedCfsAndEmptyLabels();
  }, [csfList, emptyYardList, selectedEmptyYardName, selectedCfsName])

  const loadInstructionDocTemplates = () => {
    fetchedRef.current[configKey] = true;

    dispatch(
      getInstructionDocTemplates({
        linerId,
        country: dataCountry,
        location: location ? String(location) : '',
        instructionId: 820,
        configKey,
      })
    )
      .unwrap()
      .then((data) => {
        setState(prev => ({ ...prev, templateList: data }));
      });
  };

  useEffect(() => {
    loadInstructionDocTemplates();
  }, [dataCountry, linerId, location, config, configKey]);

  useEffect(() => {
    if (!blCountry) return
    dispatch(
      getReleaseTypeList(
        { partnerCountry: blCountry, linerId: selectedLinerId }
      )
    );
    if (!language) return
    i18n.changeLanguage(
      `${blCountry}_${language}`
    );
  }, [blCountry, selectedLinerId, language]);

  useEffect(() => {
    if (!disableFields && demurrageViewForm?.list?.length > 0) {
      let tempSelectedTruckerName = {};
      let tempSelectedDate = {};
      let tempselectedPickupLocation = {};
      let tempSelectedTruckerCode = {};
      let tempSelectedtruckerId = {};
      let tempSelectedAttachmentName = {};
      let tempSelectedAttachmentFilePath = {};

      for (var i = 0; i < demurrageViewForm?.list.length; i++) {
        tempSelectedTruckerName = {
          ...tempSelectedTruckerName,
          [demurrageViewForm.list[i]?.containerNo]:
            demurrageViewForm?.list[i]?.truckerName || null,
          location: null,
        };
        tempSelectedDate = {
          ...tempSelectedDate,
          [demurrageViewForm.list[i]?.containerNo]: demurrageViewForm?.list[i]
            ?.pickupDate
            ? moment(
              demurrageViewForm?.list[i]?.pickupDate,
              'YYYY-MM-DD'
            )?.toDate()
            : null,
          intended: null,
        };
        let snContainer = data?.list?.find(
          (v: any) => v.containerNo === demurrageViewForm.list[i]?.containerNo
        );
        if (
          snContainer?.cntStatus === 'Completed' ||
          snContainer?.cntStatus?.includes('Rejected')
        ) {
          tempSelectedTruckerCode = {
            ...tempSelectedTruckerCode,
            [demurrageViewForm.list[i]?.containerNo]:
              snContainer?.truckerCode || null,
            truckerCode: null,
          };
        } else {
          tempSelectedTruckerCode = {
            ...tempSelectedTruckerCode,
            [demurrageViewForm.list[i]?.containerNo]:
              demurrageViewForm?.list[i]?.truckerCode || null,
            truckerCode: null,
          };
        }

        tempSelectedtruckerId = {
          ...tempSelectedtruckerId,
          [demurrageViewForm.list[i]?.containerNo]:
            demurrageViewForm?.list[i]?.truckerId || null,
        };

        tempselectedPickupLocation = {
          ...tempselectedPickupLocation,
          [demurrageViewForm.list[i]?.containerNo]:
            demurrageViewForm?.list[i]?.pickupLocation || null,
          location: null,
        };
      }
      for (var i = 0; i < demurrageViewForm?.extensionAttList.length; i++) {
        const key = demurrageViewForm.extensionAttList[i]?.dndInstructionAttId ?? demurrageViewForm.extensionAttList[i]?.rowNumber ?? null;
        tempSelectedAttachmentName = {
          ...tempSelectedAttachmentName,
          [key]: {
            name: demurrageViewForm?.extensionAttList[i]?.fileName || null,
          },
        };
        tempSelectedAttachmentFilePath = {
          ...tempSelectedAttachmentFilePath,
          [key]:
            demurrageViewForm?.extensionAttList[i]?.filePath || null,
        };
      }

      dispatch(updateSelectedTruckerName(tempSelectedTruckerName));
      dispatch(updateSelectedDateDV(tempSelectedDate));
      dispatch(updateSelectedtruckerCode(tempSelectedTruckerCode));
      dispatch(updateSelectedtruckerId(tempSelectedtruckerId));

      dispatch(updateSelectedPickupLocation(tempselectedPickupLocation));
      dispatch(updateSelectedAttachmentName(tempSelectedAttachmentName));
      dispatch(
        updateSelectedAttachmentFilePath(tempSelectedAttachmentFilePath)
      );
      setState(prev => ({
        ...prev,
        senderEmail: demurrageViewForm?.senderEmail
          ? demurrageViewForm?.senderEmail
          : senderEmail,
      }));
    } else if (!disableFields && data?.list?.length > 0) {
      let tempSelectedTruckerName = {};
      let tempSelectedDate = {};
      let tempselectedPickupLocation = {};
      let tempSelectedTruckerCode = {};
      let tempSelectedtruckerId = {};

      for (var i = 0; i < data?.list.length; i++) {
        tempSelectedTruckerName = {
          ...tempSelectedTruckerName,
          [data.list[i]?.containerNo]: data.list[i]?.truckerName || null,
          location: null,
        };
        tempSelectedDate = {
          ...tempSelectedDate,
          [data.list[i]?.containerNo]: data.list[i]?.pickupDate
            ? moment(data.list[i]?.pickupDate, 'YYYY-MM-DD')?.toDate()
            : selectedDate[data.list[i]?.containerNo] ?? null,
          intended: null,
        };
        tempSelectedTruckerCode = {
          ...tempSelectedTruckerCode,
          [data.list[i]?.containerNo]: data.list[i]?.truckerCode || null,
          truckerCode: null,
        };

        tempSelectedtruckerId = {
          ...tempSelectedtruckerId,
          [data.list[i]?.containerNo]: data.list[i]?.truckerId || null,
        };

        tempselectedPickupLocation = {
          ...tempselectedPickupLocation,
          [data.list[i]?.containerNo]: data.list[i]?.pickupLocation || selectedDefaultPickupLocation || null,
          location: null,
        };
      }

      dispatch(updateSelectedTruckerName(tempSelectedTruckerName));
      dispatch(updateSelectedDateDV(tempSelectedDate));
      dispatch(updateSelectedtruckerCode(tempSelectedTruckerCode));
      dispatch(updateSelectedtruckerId(tempSelectedtruckerId));

      dispatch(updateSelectedPickupLocation(tempselectedPickupLocation));
    } else {
      if (!disableFields && getUnprefixedPathname().split('/')[3] === 'instruction') {
        let tempSelectedTruckerCode = {};
        let tempselectedPickupLocation = {};

        for (var i = 0; i < data?.list?.length; i++) {
          tempSelectedTruckerCode = {
            ...tempSelectedTruckerCode,
            [data.list[i]?.containerNo]: data.list[i]?.truckerCode || null,
            truckerCode: null,
          };
          tempselectedPickupLocation = {
            ...tempselectedPickupLocation,
            [data.list[i]?.containerNo]: selectedDefaultPickupLocation || null,
            location: null,
          };
        }

        dispatch(updateSelectedtruckerCode(tempSelectedTruckerCode));
        dispatch(updateSelectedPickupLocation(tempselectedPickupLocation));
      } else {
        dispatch(updateSelectedtruckerCode({}));
        dispatch(updateSelectedPickupLocation({}));
      }

      dispatch(updateSelectedTruckerName({}));
      dispatch(updateSelectedDateDV({ intended: null }));
      dispatch(updateSelectedtruckerId({}));
      dispatch(updateSelectedAttachmentName({}));
      dispatch(updateSelectedAttachmentFilePath({}));
    }
  }, [disableFields, demurrageViewForm, data, selectedDefaultPickupLocation]);


  const loadExtensionTypesAndUnstuffingTypes = () => {
    if (!blCountry || !linerId) return;

    dispatch(extensionTypeList({ partnerCountry: blCountry, linerId }))
      .unwrap()
      .then((options: any[]) =>
        setState(prev => ({ ...prev, extensionTypeOption: options }))
      );

    dispatch(getUnstuffingTypeList({ partnerCountry: blCountry, linerId }))
      .unwrap()
      .then((options: any[]) =>
        setState(prev => ({ ...prev, unstuffingTypeOptions: options }))
      );
  };

  useEffect(() => {
    loadExtensionTypesAndUnstuffingTypes();
  }, [blCountry, linerId, dispatch]);


  // Initialize selectedNeedExtensionFor with all container numbers on fresh load
  const initSelectedNeedExtensionFor = () => {
    if (data?.list?.length > 0 && Object.keys(selectedNeedExtensionFor).length === 0) {
      const initial: { [key: string]: string } = {};
      data.list.forEach((item: any) => {
        initial[item.containerNo] = '';
      });
      setState(prev => ({ ...prev, selectedNeedExtensionFor: initial }));
    }
  };

  useEffect(() => {
    initSelectedNeedExtensionFor();
  }, [data]);



  return (
    <ReleaseInstructionConfigContext.Provider value={releaseInstructionConfig}>
      <Card style={{ minHeight: '100%' }}>
        <UnsavedChangesModal
          show={showModal}
          onHide={handleStayOnPage}
          onConfirm={handleLeavePage}
        />
        <DOExtensionHeader
          t={t}
          displayNumber={displayNumber}
          handleBack={handleBack}
          handleCopyBL={handleCopyBL}
          templateList={templateList}
          demurrageViewForm={demurrageViewForm}
          setValue={setValue}
          selectedLinerId={selectedLinerId}
          profileDetails={profileDetails}
          instructionLoading={instructionLoading}
        />
        <Card.Body
          className={
            releaseInstructionConfig?.fields?.hideCardBodyForMalaysia &&
              (oblForm?.pod === 'MYBTU' ||
                oblForm?.pod === 'MYKCH' ||
                oblForm?.pod === 'MYBKI')
              ? 'd-none'
              : 'd-block'
          }>
          <div className='container'>
            {profileDetails?.partnerType === 'customer' &&
              releaseInstructionConfig?.fields?.showUSCAMessage ? (
              <>
                <label className='form-label'>
                  Available only for imports into USA
                </label>
                <p style={{ fontSize: '12px' }}>
                  Let us know the intended pickup date for your shipment and we
                  will revert with the invoice for the PORT demurrage within some
                  minutes.
                </p>
              </>
            ) : (
              <></>
            )}
            <FormProvider {...methods}>
              <DOExtensionForm
                state={state}
                setState={setState}
                blCountry={blCountry}
                onSubmit={onSubmit}
                linerConfig={linerConfig}
                version={version}
                ShowInvoiceModal={ShowInvoiceModal}
              />
            </FormProvider>
          </div>
        </Card.Body>
        <InvoiceModal displayNumber={displayNumber} onSubmit={onSubmit} formDataInvoiceModal={formDataInvoiceModal} setShowDemurrgaeOrDeliveryModal={setShowDemurrgaeOrDeliveryModal} matchPth={matchPth} doExtensionSoftStopConfig={doExtensionSoftStopConfig} show={ShowInvoiceModal && submitOn} onHide={() => setSubmitOn(false)} />
        <DoGeneratedDialogModal demurrageForm={demurrageViewForm} updateIsProcessing={updateIsProcessing} setDoGeneratedAMS={setDoGeneratedAMS} handleBack={handleBack} matchPth={matchPth} isProcessing={isProcessing} setShowDoGeneratedDialog={setShowDoGeneratedDialog} showDoGeneratedDialog={showDoGeneratedDialog} onHide={closeDoGeneratedDialog} blCountry={blCountry} />
      </Card>
    </ReleaseInstructionConfigContext.Provider>
  );
};

export default DOExtenstion;